/** Custom event name used to signal the ReceiptPrintModal to open. */
export const RECEIPT_PRINT_EVENT = "farmsmart:receipt-print";

/**
 * Trigger the in-app receipt print modal with the given PDF blob.
 * The modal handles preview, print isolation, and auto-close after printing.
 *
 * Returns true always (kept for API compatibility with existing call sites).
 */
export const openReceiptPdfForPrint = (blob: Blob): boolean => {
  window.dispatchEvent(new CustomEvent<Blob>(RECEIPT_PRINT_EVENT, { detail: blob }));
  return true;
};
